var map = {
	"./menu_KYC.json": "./src/components/menus/data/menu_KYC.json",
	"./menu_RTP.json": "./src/components/menus/data/menu_RTP.json",
	"./menu_Remittance.json": "./src/components/menus/data/menu_Remittance.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/menus/data sync recursive ^\\.\\/menu_.*\\.json$";